import { TableCellPerColumn } from "ds/components/TableSimple/types";
import { OpenTofuMigrateStackNode } from "shared/Stack/OpenTofuMigration/gql";

import { READY_TO_MIGRATE_COLUMN_ID } from "../constants";
import OpenTofuMigrationReadyToMigrateTableNameCell from "./NameCell";
import OpenTofuMigrationReadyToMigrateTableVersionCell from "./VersionCell";

export const READY_TO_MIGRATE_TABLE_CELLS: TableCellPerColumn<OpenTofuMigrateStackNode> = {
  [READY_TO_MIGRATE_COLUMN_ID.NAME]: OpenTofuMigrationReadyToMigrateTableNameCell,
  [READY_TO_MIGRATE_COLUMN_ID.VERSION]: OpenTofuMigrationReadyToMigrateTableVersionCell,
};
